const STATUS_PACK_SCOPE_TYPES = new Set(['project', 'program', 'portfolio']);

export function normalizeStatusPackScopeType(value) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  return STATUS_PACK_SCOPE_TYPES.has(normalized) ? normalized : 'project';
}

export function buildStatusPackLibraryPath({
  scopeType = 'project',
  scopeId = '',
  scopeLabel = '',
  title = '',
  summary = '',
} = {}) {
  const params = new URLSearchParams();
  params.set('scopeType', normalizeStatusPackScopeType(scopeType));
  if (scopeId) params.set('scopeId', String(scopeId).trim());
  if (scopeLabel) params.set('scopeLabel', String(scopeLabel).trim());
  if (title) params.set('title', String(title).trim());
  if (summary) params.set('summary', String(summary).trim());
  return `/status-packs?${params.toString()}`;
}
